import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { GROUP_INFO } from "../../data/companies";
import logo from "../../assets/d_d_lanka_new_logo.webp";

const Footer = () => (
  <footer className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 text-slate-200 py-16 px-6 border-t-4 border-blue-500">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
      <div className="space-y-4">
        <div className="w-32 h-16 flex items-center justify-center mx-auto">
          <img
            src={logo}
            alt="D&D Lanka"
            className="max-w-full max-h-full object-contain filter brightness-110 drop-shadow-[0_10px_30px_rgba(0,0,0,0.8)]"
          />
        </div>
        <h3 className="text-2xl font-black text-white flex items-center gap-2">
          {GROUP_INFO.name}
        </h3>
        <p className="text-slate-300/80 leading-relaxed text-sm backdrop-blur-sm">
          {GROUP_INFO.description}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <h4 className="font-bold text-slate-200 mb-4 bg-blue-500/20 px-4 py-2 rounded-lg inline-block">
            Industries
          </h4>
          <p className="text-sm hover:text-blue-400 cursor-pointer transition-colors group-hover:scale-105">
            Imports
          </p>
          <p className="text-sm hover:text-blue-400 cursor-pointer transition-colors">
            Exports
          </p>
          <p className="text-sm hover:text-blue-400 cursor-pointer transition-colors">
            Apparels & Textiles
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-bold text-slate-200 mb-4 bg-blue-500/20 px-4 py-2 rounded-lg inline-block">
            Corporate
          </h4>
          <p className="text-sm hover:text-blue-400 cursor-pointer transition-colors">
            Governance
          </p>
          <p className="text-sm hover:text-blue-400 cursor-pointer transition-colors">
            Investors
          </p>
          <p className="text-sm hover:text-blue-400 cursor-pointer transition-colors">
            Careers
          </p>
        </div>
      </div>

      <div className="bg-slate-800/50 p-8 rounded-2xl border border-blue-900/50 backdrop-blur-sm shadow-2xl">
        <h4 className="font-bold text-slate-100 mb-6 flex items-center gap-2 text-lg">
          <MapPin className="text-blue-400" size={20} />
          Headquarters
        </h4>
        <div className="space-y-4 text-sm">
          <div className="flex items-center gap-3 p-3 bg-slate-700/50 rounded-xl hover:bg-blue-500/20 transition-all group">
            <MapPin
              size={16}
              className="text-blue-400 group-hover:text-blue-300 flex-shrink-0"
            />
            <span>
              73/6/1, U.L.L Perera Mawatha, Thudella, Kuruduwatta, Ja-Ela, Sri
              Lanka
            </span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-slate-700/50 rounded-xl hover:bg-blue-500/20 transition-all group">
            <Phone
              size={16}
              className="text-blue-400 group-hover:text-blue-300 flex-shrink-0"
            />
            <a href="tel:+94778197763">+94 77 8 197 763</a>
          </div>
          <div className="flex items-center gap-3 p-3 bg-slate-700/50 rounded-xl hover:bg-blue-500/20 transition-all group">
            <Phone
              size={16}
              className="text-blue-400 group-hover:text-blue-300 flex-shrink-0"
            />
            <a href="tel:+94706936939">+94 70 6 936 939</a>
          </div>
          <div className="flex items-center gap-3 p-3 bg-slate-700/50 rounded-xl hover:bg-blue-500/20 transition-all group">
            <Mail
              size={16}
              className="text-blue-400 group-hover:text-blue-300 flex-shrink-0"
            />
            <span>spicegrainsagrocmb@gmail.com</span>
          </div>
        </div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto mt-12 pt-10 border-t border-slate-800/50 text-center text-xs text-slate-400 bg-slate-900/30 backdrop-blur-sm rounded-3xl mx-6">
      <p>
        © {new Date().getFullYear()} {GROUP_INFO.name}. Precision • Innovation •
        Global Reach.
      </p>
    </div>
  </footer>
);

export default Footer;
